import {inject, Injectable} from '@angular/core';
import {GetSelectDataParams, SelectData} from "../../../../core/types/records-table.types";
import {
  propertyLazySelectFileDestinations,
  propertyLazySelectRecordCalendarTgIds
} from "../configs/telegram-chat-window-config";
import {RecordTableApiService} from "../../../../core/services-api/record-table-api.service";

@Injectable({
  providedIn: 'root'
})
export class TelegramSelectDataService {
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public getSelectRecordCalendarIdData(chatId: number, accountId: string): Promise<Array<SelectData>> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: propertyLazySelectRecordCalendarTgIds,
      id: chatId,
      value: accountId
    };

    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(getSelectDataParams).subscribe({
        next: (selectData: Array<SelectData>) => resolve(selectData),
        error: (error) => reject(error)
      });
    });
  }

  public getSelectFileDestinationData(): Promise<Array<SelectData>> {
    const getSelectDataParams: GetSelectDataParams = {
      propertyLazySelect: propertyLazySelectFileDestinations
    };

    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(getSelectDataParams).subscribe({
        next: (selectData: Array<SelectData>) => resolve(selectData),
        error: (error) => reject(error)
      });
    });
  }
}
